<template>
  <div @click="info" class="course-item">
    <img :src="courseData.thumb" alt class="course-img" />
    <div class="name">{{courseData.courseName}}</div>
    <div
      class="duration"
      v-if="!isRecommend"
    >{{'共'+courseData.classCount+"个课时" + ", 当前已观看" +learnCount+"个课时"}}</div>
    <div class="duration" v-if="isRecommend">{{'共'+courseData.classCount+"个课时" }}</div>
    <el-progress :percentage="learnProgress" class="progress" v-if="isShowProcess"></el-progress>
  </div>
</template>
<script>
import * as COURSE_API from '@/api/ChannelCourseAPI'
export default {
  props: ["courseData", "isShowProcess", 'isRecommend'],
  data () {
    return {
      learnProgress: 0,             //当前学习进度
      learnCount: 0,                //当前学习课时数
      tourist : localStorage.getItem('tourist')  || sessionStorage.getItem('tourist')
    }
  },
  mounted () {
     console.log(this.tourist,'wwe')
    if(this.tourist == 'false'){
      this.GetLearnProgress()
    }else{
           console.log(this.tourist,'ww777e')
      this.isRecommend =true
    }

  },
  methods: {
    GetLearnProgress () {
      let data = {
        courseId: this.courseData.courseId
      }
      COURSE_API.GetCourseInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.learnProgress = parseInt(res.data.progress * 100);
            this.learnCount = res.data.learnCount;
          } else if (data.code === 401) {
            this.$message.error('登录失效，请重新登录')
            this.$router.push({
              name: 'login'
            })
          } else {
            this.learnProgress = 0
            this.learnCount = 0
          }
        })
    },
    info () {
      let data = {
        courseData: this.courseData,
        isRecommend: this.isRecommend
      }
      setTimeout(() => {
        this.$router.push(
          {
            name: 'CourseDetail',
            params: data
          }
        )
        sessionStorage.setItem('curriculumSchedule', JSON.stringify(data))
      }, 200)
    }
  }
}
</script>
<style lang="less" scoped>
.course-item {
  width: 360px;
  margin-top: 20px;
  &:not(:nth-child(3n)) {
    margin-right: 61px;
  }
  .course-img {
    width: 360px;
    height: 203px;
    border-radius: 10px;
  }
  .name {
    margin-top: 19px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(26, 26, 26, 1);
  }
  .duration {
    margin-top: 14px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .progress {
    margin-top: 22px;
  }
}
</style>